/**
 * craft_feed.ts — NPC craft that should be HEARD (2026-09-20). PURE, globalThis-backed (the air_targets pattern).
 *
 * Other PLAYERS' craft are read straight off `atlas.remotes`. NPC craft — a versona crossing the sky to another town,
 * a cargo freighter and its escorts on the trade lane — are drawn by their own modules in their own coordinates; those
 * modules REPORT what they draw, each frame they draw it, and the audio runtime module voices the nearest few together
 * with the players' (lib/audio/passing_craft.ts). A report is a LEASE: a module that stops drawing a craft (it landed,
 * it was shot down, the module died) simply stops reporting and the engine fades — nothing to unregister, nothing to leak.
 */
import type { CraftKind } from './passing_craft.js';

export interface CraftReport { id: string; kind: CraftKind; x: number; y: number; z: number; atMs: number }
export const CRAFT_LEASE_MS = 700;

interface Feed { craft: Map<string, CraftReport> }
const holder = globalThis as unknown as { __atlasCraftFeed?: Feed };
const feed = (): Feed => (holder.__atlasCraftFeed ??= { craft: new Map() });

/** "I am drawing this craft HERE, now." ABSOLUTE world coordinates (the ABSOLUTE-IN law). */
export function reportCraft(id: string, kind: CraftKind, x: number, y: number, z: number, nowMs: number): void {
  const f = feed(), r = f.craft.get(id);
  if (r) { r.kind = kind; r.x = x; r.y = y; r.z = z; r.atMs = nowMs; }
  else f.craft.set(id, { id, kind, x, y, z, atMs: nowMs });
}

/** Every craft reported within the lease (expired ones are dropped as they are found). */
export function liveCraft(nowMs: number): CraftReport[] {
  const out: CraftReport[] = [];
  const f = feed();
  for (const [id, r] of f.craft) { if (nowMs - r.atMs <= CRAFT_LEASE_MS) out.push(r); else f.craft.delete(id); }
  return out;
}
